let targetsList = ['locale-selectors__content', 'js-trigger-locale-select', 'locale-selectors__selector', 'locale-selectors__selector', 'locale-select', 'locale-selectors__content form', "wg-exclude"]

// Hide form when click outside element
document.onclick = function(e){
  let removeOrNot = true;
  targetsList.forEach(element => {
      if(e.target.classList.contains(element)){
          removeOrNot = false;
          return;
      }
  });
  if(removeOrNot)
      document.querySelector('.locale-selectors__content')?.classList.remove('show');
}

function waitForElm(selector) {
return new Promise(resolve => {
    if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
    }
    const itemObserver = new MutationObserver(mutations => {
        if (document.querySelector(selector)) {
            resolve(document.querySelector(selector));
            itemObserver.disconnect();
        }
    });
    itemObserver.observe(document.body, {
        childList: true,
        subtree: true
    });
});
}
var newCountrySelector = document.querySelector('.custom-select-country-js')
function editPopupSelectLanguage() {
waitForElm('.recommendation-modal__selector[name="locale_code"]').then((elm) => {
  var oldCountrySelector = document.querySelector('.recommendation-modal__selector[name="locale_code"]'),
      parentElement = oldCountrySelector.parentNode;
      parentElement.replaceChild(newCountrySelector, oldCountrySelector);
      if(!newCountrySelector.classList.contains('recommendation-modal__selector')) {
        newCountrySelector.classList.add('recommendation-modal__selector');
      }
})
}

const body = document.querySelector('body'); 
body.addEventListener('click', function(event) {
if (event.target && event.target.matches('.recommendation-modal__content .recommendation-modal__button--minimal')) {
  editPopupSelectLanguage()
}
});

body.addEventListener('change', function(event) {
if (event.target && event.target.matches('.recommendation-modal__form .recommendation-modal__selector--flag[name="country_code"]')) {
  removeSecondSelect()
}
});

function removeSecondSelect() {
waitForElm('.recommendation-modal__container .recommendation-modal__selector-wrapper .recommendation-modal__selector:nth-child(2)').then((elm) => {
  elm.remove();
})
}

// When the language selector changes
const customSelectCountry = document.querySelector('.custom-select-country-js');
if (customSelectCountry) {
  customSelectCountry.addEventListener('change', function() {
    const pictoLanguage = document.querySelector('.wg-exclude.picto-language');
    if (pictoLanguage) {
      pictoLanguage.innerHTML = this.value;
    }
    
    const selectedOption = this.querySelector(`option[value=${this.value}]`);
    if (selectedOption) {
      selectedOption.setAttribute('selected', "true");
    }
  });
}